import { Component } from '@angular/core';
import {FormInputComponent} from "../../utils/form-input/form-input.component";
import {MdbButtonComponent} from "../../utils/mdb-button/mdb-button.component";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-auth-wrapper',
    imports: [
        FormInputComponent,
        MdbButtonComponent,
        ReactiveFormsModule,
        TranslateModule
    ],
    templateUrl: './auth-wrapper.component.html',
    styleUrl: './auth-wrapper.component.scss'
})
export class AuthWrapperComponent {

}
